import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import AddServiceManForm from "../forms/addServiceManForm/AddServiceManForm";
import TabPanel from "../serviceList/Tabpanel/TabPanel";
import EditIcon from "@mui/icons-material/Edit";
import { Chip } from "@mui/material";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import AppConstants from "../../../AppConstants";
import avathar from "../../../dummyImages/avathar.jpg";
import { Spinner } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import ServiceManLocation from "./serviceManLocation";

export const ServiceManDetails = () => {
  const [open, setOpen] = useState(false);

  const [categoryList, setCategoryList] = useState([]);
  const [serviceManList, setServiceManList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedServiceMan, setSelectedServiceMan] = useState(null);
  const [showSuspendPopup, setShowSuspendPopup] = useState(false);
  const [serviceManToSuspend, setServiceManToSuspend] = useState(null);
  const [openLocation, setOpenLocation] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const config = useMemo(() => {
    return getConfig();
  }, []);
  let bID = localStorage.getItem(AppConstants.business_id);

  const handleAddForm = () => {
    setSelectedServiceMan();
    setOpen(true);
  };
  const handleEditForm = (serviceMan = null) => {
    setSelectedServiceMan(serviceMan);
    setOpen(true);
  };
  const handleCloseForm = () => {
    setSelectedServiceMan(null);
    setOpen(false);
  };

  const confirmSuspend = () => {
    if (serviceManToSuspend) {
      suspendServiceMan(serviceManToSuspend);
    }
    setShowSuspendPopup(false);
    setServiceManToSuspend(null);
  };

  const handleLocation = (id) => {
    setOpenLocation(true);
    fetchServiceManDetail(id);
  };

  const fetchServiceManDetail = (id) => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/worker/${id}/`, config)
      .then((response) => {
        setLoading(false);
        setLatitude(response.data.latitude);
        setLongitude(response.data.longitude);
      })
      .catch((error) => {
        console.error("Serviceman Error:", error);
        setLoading(false);
      });
  };

  const handleCloseLocation = () => {
    setOpenLocation(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const suspendServiceMan = (userId) => {
    setLoading(true);
    const serviceMan = serviceManList.find((u) => u.user === userId);
    const isSuspended = serviceMan?.is_suspended ? "False" : "True";
    axios
      .post(
        `${baseUrl}auth/suspend-user/${userId}/`,
        { is_suspended: isSuspended },
        {
          headers: {
            ...config.headers,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        fetchServiceMan();
        setSnackbar({
          open: true,
          message: response.data.detail,
          severity: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
        setLoading(false);
      });
  };

  const handleSuspendClose = () => {
    setShowSuspendPopup(false);
  };

  const fetchCategory = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/categories-by-business/${bID}/`, config)
      .then((response) => {
        setLoading(false);
        setCategoryList(response.data);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  const fetchServiceMan = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/workers-by-business/${bID}/`, config)
      .then((response) => {
        setLoading(false);
        const fetchedData = response.data || [];
        setServiceManList(fetchedData);
      })
      .catch((error) => {
        console.error("Service Error:", error);
        setLoading(false);
      });
  };

  const fetchService = () => {
    setLoading(true);
    axios
      .get(baseUrl + `app/services-list-by-business/${bID}/`, config)
      .then((response) => {
        setLoading(false);
        setServiceList(response.data);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  const handleFormSubmit = (formData) => {
    const url = selectedServiceMan
      ? `${baseUrl}businessadmin/worker-update/${selectedServiceMan.id}/`
      : `${baseUrl}businessadmin/worker/`;

    const method = selectedServiceMan ? "put" : "post";

    const form = new FormData();
    if (formData.profilePic && formData.profilePic instanceof File) {
      form.append("worker_image", formData.profilePic);
    }
    form.append("worker_name", formData.serviceManName);
    form.append("service", JSON.stringify(formData.service));
    form.append("mobile_number", formData.phone);
    form.append("experience", formData.experience);
    form.append("address", formData.address);
    form.append("location", formData.location);
    form.append("district", formData.district);
    form.append("email", formData.email);
    form.append("postal_name", formData.postalName);
    form.append("zipnumber", formData.zipNumber);

    axios({
      method,
      url,
      data: form,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        fetchServiceMan();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        setOpen(false);
      })
      .catch((error) => {
        console.error("Error saving service man details:", error);
      });
  };

  useEffect(() => {
    fetchCategory();
    fetchServiceMan();
    fetchService();
  }, []);

  return (
    <div className="main-div">
      <button className="btn-add" onClick={handleAddForm}>
        + Add Technician Details
      </button>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 500, sm: 1000, lg: 1350 },
            bgcolor: "background.paper",
          }}
        >
          <TabPanel>
            <DataGrid
              rows={serviceManList}
              columns={[
                { field: "id", headerName: "ID", width: 90 },
                {
                  field: "worker_image",
                  headerName: "Photo",
                  width: 100,
                  renderCell: (params) => (
                    <img
                      src={params.value}
                      alt={avathar}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        padding: "5px",
                      }}
                    />
                  ),
                },

                {
                  field: "worker_name",
                  headerName: "Technician Name",
                  width: 150,
                },
                { field: "service_name", headerName: "Service", width: 150 },
                { field: "category_name", headerName: "Category", width: 150 },
                { field: "experience", headerName: "Experience", width: 150 },
                {
                  field: "is_available",
                  headerName: "Current Status",
                  width: 200,
                  renderCell: (params) => (
                    <Chip
                      label={params.value ? "online" : "offline"}
                      style={{
                        backgroundColor: params.value ? "green" : "red",
                        color: "white",
                      }}
                    />
                  ),
                },
                {
                  field: "is_suspended",
                  headerName: "susupend",
                  width: 200,
                  renderCell: (params) => (
                    <Chip
                      label={params.value ? "Suspended" : "Active"}
                      style={{
                        backgroundColor: params.value ? "red" : "green",
                        color: "white",
                      }}
                    />
                  ),
                },
                {
                  field: "mobile_number",
                  headerName: "Phone Number",
                  width: 150,
                },
                { field: "address", headerName: "Address", width: 150 },
                { field: "location", headerName: "Location", width: 150 },
                { field: "district", headerName: "District", width: 150 },
                { field: "email", headerName: "Email", width: 150 },
                { field: "postal_name", headerName: "Postal Name", width: 150 },
                { field: "zipnumber", headerName: "Zip Number", width: 150 },
                {
                  field: "actions",
                  headerName: "Actions",
                  width: 250,
                  renderCell: (params) => (
                    <div className="action-btn">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={(e) => {
                          handleLocation(params.row.id);
                        }}
                      >
                        Location
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => handleEditForm(params.row)}
                      >
                        <EditIcon />
                      </Button>
                    </div>
                  ),
                },
              ]}
              pageSizeOptions={[25, 50, 100]}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              disableSelectionOnClick
            />
          </TabPanel>

          {/* Add Service Form Dialog */}
          <AddServiceManForm
            open={open}
            onClose={handleCloseForm}
            serviceList={serviceList}
            categoryList={categoryList}
            serviceMan={selectedServiceMan}
            onSubmit={handleFormSubmit}
          />

          <Dialog
            open={showSuspendPopup}
            onClose={() => setShowSuspendPopup(false)}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Do you really want to Suspend?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ textTransform: "none" }}
                onClick={confirmSuspend}
              >
                Suspend
              </Button>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                  color: "grey",
                  outline: "1px solid grey",
                }}
                onClick={handleSuspendClose}
              >
                cancel
              </Button>
            </DialogActions>
          </Dialog>
          <ServiceManLocation
            open={openLocation}
            onClose={handleCloseLocation}
            latitude={latitude}
            longitude={longitude}
          />
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Box>
      )}
    </div>
  );
};
